import {
  Link,
  Wrapper,
  SessionLogout,
  ConnectionView,
  Icon,
  PartAdminMenu,
  Inserter,
  SessionRole,
  Image,
} from "nystem-components";
import { useState, useEffect } from "react";
import app from "nystem";

const PartMenu = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = () => {
      if (open === true) setOpen(false);
    };
    setTimeout(() => {
      window.addEventListener("click", close);
    }, 0);
    return () => {
      window.removeEventListener("click", close);
    };
  }, [open]);

  return (
    <Wrapper
      renderAs="header"
      className="bg-menu py-1 fixed top-0 z-20 w-full pl-3 pr-2 md:mx-0 print-hidden"
    >
      <Wrapper
        renderAs="nav"
        className="flex max-w-2xl m-auto text-sm justify-center items-center mt-2"
      >
        <Link to="/" exact="true">
          <ConnectionView>
            <Image src="/image/logo.jpg" width="120" heght="48" alt="logo" />
          </ConnectionView>
          <ConnectionView offline="true">
            <Image
              src="/image/logo.jpg"
              width="120"
              heght="48"
              className="grayscale"
              alt="logo"
            />
          </ConnectionView>
        </Link>
        <Inserter
          match="*"
          className="ml-6 font-bold"
          source="/menu/view/main"
        />
        <Wrapper className="flex flex-grow h-14"></Wrapper>
        <SessionRole userrole="config super" className="hidden">
          <Icon
            icon="bars"
            className="shadow mx-1 rounded bg-white/30 p-1 w-10 h-10 cursor-pointer"
            onClick={() => setOpen(!open)}
          />
          <Wrapper className="relative w-1">
            {open ? (
              <Wrapper className="absolute w-32 mt-6 right-0 text-sm shadow mx-1 rounded bg-white/60 p-1">
                <PartAdminMenu />
                <SessionLogout
                  type="button"
                  className="shadow ml-4 mt-3 rounded bg-white/30 p-1 text-center"
                >
                  {app.t("Log out")}
                </SessionLogout>
              </Wrapper>
            ) : null}
          </Wrapper>
        </SessionRole>
        <SessionRole userrole="user">
          <SessionLogout
            type="button"
            className="shadow rounded bg-white/30 text-center cursor-pointer p-1 ml-1"
          >
            <Icon icon="right-from-bracket" className="w-8 h-8" />
          </SessionLogout>
        </SessionRole>
      </Wrapper>
    </Wrapper>
  );
};
export default PartMenu;
